import React from 'react';
import { FormattedMessage } from 'react-intl';
import FacebookShare from 'src/components/FacebookShare/FacebookShare';
import MobileSharePopup from '../SharePopup/MobileSharePopup';
import DonateButton from '../Page/DonateButton';
import { AnalyticsClick } from 'src/redux/modules/analytics';

interface Props {
  ownerName: string;
  pageName: string;
  analitycsClick: AnalyticsClick;
  ownerProfileImage?: string;
}

class MobileEncourageShareAndDonate extends React.Component<Props> {
  render() {
    const {
      ownerName,
      pageName,
      analitycsClick,
      ownerProfileImage,
    } = this.props;
    return (
      <MobileSharePopup
        ownerProfileImage={ownerProfileImage}
        ownerName={ownerName}
      >
        <>
          <h1>
            <FormattedMessage
              id="MobileEncourageShareAndDonate.title"
              defaultMessage="Plenty of ways to support a good cause"
            />
          </h1>

          <p className="jg-space-mbml">
            <FormattedMessage
              id="MobileEncourageShareAndDonate.didYouKnow"
              defaultMessage="You can support {ownerName}’s cause by donating today or you can help reach more supporters by sharing with your friends."
              values={{
                ownerName,
              }}
            />
          </p>

          <div className="row">
            <div className="col-sm-6">
              <DonateButton
                isActive
                name={pageName}
                pageSection="page > donate prompt"
                donate={page => {
                  analitycsClick({
                    event: 'link click',
                    eventValue: 'donate',
                    pageSection: 'page > donate prompt',
                    subtype: 'button',
                  });
                }}
              />
            </div>
            <div className="col-sm-6">
              <FacebookShare
                buttonText="Share"
                location="page > share prompt"
                className="jg-space-mbmd"
              />
            </div>
          </div>
        </>
      </MobileSharePopup>
    );
  }
}

export default MobileEncourageShareAndDonate;



// WEBPACK FOOTER //
// ./src/components/EncourageShareAndDonate/MobileEncourageShareAndDonate.tsx